import { Col, DatePicker, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Maybe } from 'graphql/jsutils/Maybe';
import moment, { Moment } from 'moment';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { extractTranslation } from '../../../helpers/formatters';
import { getAppointmentTypeName } from '../../../helpers/utils';
import {
  Resource_AppointmentLocation,
  Resource_AppointmentTypeMsg,
} from '../../../src/generated/graphql';
import { AppointmentRequestButton } from '../../common-layout/appointment-request-button';
import styles from '../facility-selection.module.scss';

interface TimeFrameRequestProps {
  clinicId: Maybe<string> | undefined;
  officeHourId: Maybe<string> | undefined;

  appointmentType: Maybe<Resource_AppointmentTypeMsg> | undefined;
  appointmentLocation: Maybe<Resource_AppointmentLocation> | undefined;
}

export const TimeFrameRequest: FC<TimeFrameRequestProps> = ({
  clinicId,
  officeHourId,
  appointmentType,
  appointmentLocation,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const [timeFrameStart, setTimeFrameStart] = useState<Moment | null>(null);
  const [timeFrameEnd, setTimeFrameEnd] = useState<Moment | null>(null);

  const appointmentTypeName = extractTranslation(
    getAppointmentTypeName(appointmentType),
    router.locale
  );

  return (
    <div className={styles.nextAvailableAppointmentsWrapper}>
      <Title level={3}>
        {formatMessage({
          id: 'facility-selection.appointment-request',
        })}
        {appointmentType && ` | ${appointmentTypeName}`}
      </Title>
      <p className={"ant-list-item-meta-description description"}>
        {formatMessage({
          id: 'facility-selection.appointment-request.description',
        })}
      </p>
      <p style={{ color: 'darkgray' }}>
        {formatMessage({
          id: 'appointment-request.time-frame.details',
        })}
      </p>
      <Row gutter={16}>
        <Col span={12}>
          <DatePicker
            style={{ width: '100%', marginBottom: 22 }}
            placeholder={formatMessage({ id: 'placeholder.start-date' })}
            value={timeFrameStart}
            format={'DD.MM.YYYY'}
            onChange={(value) => {
              setTimeFrameStart(value ? moment(value).startOf('day') : null);
            }}
            disabledDate={(current) =>
              current.isBefore(moment().subtract(1, 'day')) || current.isAfter(moment(timeFrameEnd))
            }
          />
        </Col>
        <Col span={12}>
          <DatePicker
            style={{ width: '100%', marginBottom: 22 }}
            placeholder={formatMessage({ id: 'placeholder.end-date' })}
            value={timeFrameEnd}
            format={'DD.MM.YYYY'}
            onChange={(value) => {
              setTimeFrameEnd(value ? moment(value).endOf('day') : null);
            }}
            disabledDate={(current) =>
              current.isBefore(moment().subtract(1, 'day')) ||
              current.isBefore(moment(timeFrameStart))
            }
          />
        </Col>
      </Row>

      {officeHourId && (
        <AppointmentRequestButton
          appointmentLocation={appointmentLocation}
          clinicId={clinicId}
          officeHourId={officeHourId}
          note={null}
          slot={null}
          directBooking={false}
          timeFrameStart={timeFrameStart}
          timeFrameEnd={timeFrameEnd}
          appointmentType={appointmentType}
        />
      )}
    </div>
  );
};
